/**
 * @generated SignedSource<<db09a6667a6e50344d9fe7ef784e7ea9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DagvestigationJobDetails_jobRun$data = {
  readonly alertEvent: {
    readonly alertEventGroup: {
      readonly " $fragmentSpreads": FragmentRefs<"AlertGroupContextBanner_alertEventGroup">;
    } | null | undefined;
    readonly id: any;
  } | null | undefined;
  readonly id: any;
  readonly investigation: {
    readonly id: any;
    readonly summary: string;
  } | null | undefined;
  readonly job: {
    readonly alert: {
      readonly id: any;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly id: any;
  };
  readonly name: string;
  readonly outputJson: any | null | undefined;
  readonly status: GraphQLJobRunStatus;
  readonly updatedAt: any;
  readonly " $fragmentSpreads": FragmentRefs<"JobRunDetails_jobRun">;
  readonly " $fragmentType": "DagvestigationJobDetails_jobRun";
};
export type DagvestigationJobDetails_jobRun$key = {
  readonly " $data"?: DagvestigationJobDetails_jobRun$data;
  readonly " $fragmentSpreads": FragmentRefs<"DagvestigationJobDetails_jobRun">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DagvestigationJobDetails_jobRun",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outputJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAlertEvent",
      "kind": "LinkedField",
      "name": "alertEvent",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAlertEventGroupSummary",
          "kind": "LinkedField",
          "name": "alertEventGroup",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AlertGroupContextBanner_alertEventGroup"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobRunDetails_jobRun"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLInvestigation",
      "kind": "LinkedField",
      "name": "investigation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLJob",
      "kind": "LinkedField",
      "name": "job",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAlert",
          "kind": "LinkedField",
          "name": "alert",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLJobRun",
  "abstractKey": null
};
})();

(node as any).hash = "14de9859d690bf1936568d5b94ed2491";

export default node;
